import React from 'react';
import { Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import { OrganizationDetailTable } from './_';

const makeStyles = () => ({
  pageContainer: {
    height: '100%',
  },
});
export function OrganizationDetailPage() {
  const sx = makeStyles();
  const { id } = useParams<{ id: string }>();
  return (
    <Grid sx={sx.pageContainer} container justifyContent="center" alignItems="center">
      {/* Keyed by id: opening another organization starts with fresh page, filters and selection. */}
      <OrganizationDetailTable key={id} />
    </Grid>
  );
}
